import Methods from "../methods";
import dateformat from 'dateformat'
import {formatDate} from "../../util/date-util";

const searchOrders = (context, payload) => {
  const {filters, page, size, sortBy = "orderDate", direction = "desc"} = payload;
  const url = `api/orders/search/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const loadOrderList = (context, payload) => {
  const url = `api/orders?${payload.params}`
  return Methods.doGet(context, url, null)
}

const loadOrderListWithFilters = (context, payload) => {
  const url = `api/orders-filters?${payload.params}`
  return Methods.doGet(context, url, null)
}

const loadTrackingOrderList = (context, payload) => {
  const url = `api/orders/tracking/${payload.idOrder}`
  return Methods.doGet(context, url, null)
}

const approveOrder = (context, payload) => {
  const url = `api/orders/${payload.idOrder}/approve`
  return Methods.doPatch(context, url, {}, null)
}

const sendOrder = (context, payload) => {
  const url = `api/orders/send`
  return Methods.doPatch(context, url, payload, null)
}

const confirmOrder = (context, idOrder, request) => {
  const url = `api/orders/${idOrder}/confirm`
  return Methods.doPatch(context, url, request, null)
}

const loadReportOrders = (context, payload) => {
  const url = `report/orders`
  if (!payload.filters.isExport) {
    return Methods.doPost(context, url, payload.filters, null)
  } else {
    return Methods.doPostDonwload(context, url, payload.filters, `report-pedidos-${payload.nameClient}`, null)
  }
}

const orderReportExportExcel = (context, payload) => {
  const url = `api/report/orders/client/${payload.filters.idClient}/excel`
  return Methods.doPostDonwload(
    context,
    url,
    payload.filters,
    `reporte-pedidos-${payload.nameClient}`,
    null
  )
}

const orderReportExportExcelDetail = (context, payload) => {
  const url = `api/report/orders/client/${payload.filters.idClient}/excel-detail`
  return Methods.doPostDonwload(
    context,
    url,
    payload.filters,
    `reporte-pedidos-${payload.nameClient}-detallado`,
    null
  )
}

const loadReportForOrder = (context, payload) => {
  const url = `report/orders/${payload.order.id}?${payload.params}`
  if (payload.params === "resume=true") {
    return Methods.doPostDonwload(context, url, {extExport: 'pdf'}, `reporte-resumen-pedido-${payload.nameClient}-${dateformat(payload.order.orderDate, "dd-mm-yyyy")}`, null)
  } else {
    return Methods.doPostDonwload(context, url, {extExport: 'pdf'}, `reporte-pedido-${payload.nameClient}-${dateformat(payload.order.orderDate, "dd-mm-yyyy")}`, null)
  }
}

const loadItemsLocationFromOrder = (context, payload) => {
  const url = `api/orders/${payload.idOrder}/items`
  return Methods.doGet(context, url, null)
}

const loadReportForOrderGuia = (context, payload) => {
  const url = `report/orders/guia/${payload.order.id}`
  return Methods.doPostDonwload(context, url, {extExport: 'pdf'}, `guia-pedido-${payload.nameClient}-${dateformat(payload.order.orderDate, "dd-mm-yyyy")}`, null)
}

const downloadVaultOrderPdf = (context, id) => {
  const url = `report/orders/${id}/vault`;

  const newDate = formatDate(new Date());
  const fileName = `Orden_pedido` + "_" + newDate + ".pdf";
  return Methods.doPostDonwload(context, url, {}, fileName, null);
};

const exportOrdersExcel = (context, filters) => {
  const url = `report/orders/export-excel`;

  const newDate = formatDate(new Date());
  const fileName = `Reporte_pedidos_${newDate}.xlsx`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const exportOrdersPdf = (context, filters) => {
  const url = `report/orders/export-pdf`;

  const newDate = formatDate(new Date());
  const fileName = `Reporte_pedidos_${newDate}.pdf`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

export default {
  searchOrders,
  loadOrderList,
  loadOrderListWithFilters,
  loadTrackingOrderList,
  approveOrder,
  sendOrder,
  confirmOrder,
  loadReportOrders,
  loadReportForOrder,
  loadItemsLocationFromOrder,
  loadReportForOrderGuia,
  orderReportExportExcel,
  orderReportExportExcelDetail,
  downloadVaultOrderPdf,
  exportOrdersExcel,
  exportOrdersPdf
}



// WEBPACK FOOTER //
// ./src/api/modules/OrderApi.js